import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

// Get API URL with fallback
const getApiUrl = () => {
  const apiUrl = import.meta.env.VITE_API_URL;
  
  if (!apiUrl) {
    console.warn('⚠️ VITE_API_URL not set, using fallback');
    
    if (typeof window !== 'undefined') {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost:8901/api';
      }
      
      return `${protocol}//${hostname}/api`;
    }
    
    return 'http://localhost:8901/api';
  }
  
  console.log('✅ API URL configured:', apiUrl);
  return apiUrl;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery({
    baseUrl: getApiUrl(),
  }),
  tagTypes: [
    // ===== AUTH & USERS =====
    'Auth',
    'Users',
    'Sessions',
    
    // ===== EVENT MANAGEMENT =====
    'Events',
    'EventCategories',
    'Venues',
    'Tickets',
    'Bookings',
    'Organizers',
    'Attendees',
    'Reviews',
    
    // ===== AI PLATFORM =====
    'Projects',
    'Agents',
    'AgentTasks',
    'Deployments',
    'Integrations',
    'Collaborations',
    'CodeGenerations',
    
    // ===== INFRASTRUCTURE =====
    'Notifications',
    'Analytics',
    'SystemMetrics',
    'chat',
    'payments'
  ],
  endpoints: () => ({}),
});
